/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_After_LeadInputs */

const en_coaches_page_after_lead = /** @type {(inputs: Coaches_Page_After_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After the visit, it is all in the app.`)
};

const pl_coaches_page_after_lead = /** @type {(inputs: Coaches_Page_After_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Po wizycie wszystko w aplikacji.`)
};

/**
* | output |
* | --- |
* | "After the visit, it is all in the app." |
*
* @param {Coaches_Page_After_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_after_lead = /** @type {((inputs?: Coaches_Page_After_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_After_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_after_lead(inputs)
	return en_coaches_page_after_lead(inputs)
});